<template>
  <div>
    <v-row v-if="statement.subjects.debtors.length">
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о должнике</div>

        <Step1 :statement="statement" />
      </v-col>
    </v-row>

    <v-row v-if="statement.subjects.creditors.length">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Сведения о кредиторе (если кредиторов несколько, раздел заполняется в
          отношении каждого кредитора)
        </div>

        <Step2 :statement="statement" />
      </v-col>
    </v-row>

    <v-row v-if="statement.acceptanceEscrowDetails">
      <v-col cols="12">
        <div class="form-base__title step-name">Форма сделки</div>

        <Step3 :data="statement.acceptanceEscrowDetails" />
      </v-col>
    </v-row>

    <v-row v-if="statement.debtorAccountBankDetails">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата должнику безналичных денежных средств,
          направленных на депонирование
        </div>

        <BankDetails :data="statement.debtorAccountBankDetails" />
      </v-col>
    </v-row>

    <v-row v-if="statement.acceptanceEscrowStep5">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>

        <StepRequisites
          :data="statement.acceptanceEscrowStep5"
          :statement-type="StatementType.ACCEPTANCE_ESCROW"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>

        <StepSign :data="statement.locationStep" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Step1 from '@/components/elements/statement/FullStatementView/steps/AcceptanceEscrow/Step1';
import Step2 from '@/components/elements/statement/FullStatementView/steps/AcceptanceEscrow/Step2';
import Step3 from '@/components/elements/statement/FullStatementView/steps/AcceptanceEscrow/Step3';
import BankDetails from '@/components/elements/statement/FullStatementView/elements/BankDetails';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';

export default {
  name: 'AcceptanceEscrow',
  components: {
    BankDetails,
    Step1,
    Step2,
    Step3,
    StepRequisites,
    StepSign,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    StatementType,
  }),
};
</script>
